import { render, staticRenderFns } from "./SelectionTile.vue?vue&type=template&id=89b3903e&lang=pug"
import script from "./SelectionTile.vue?vue&type=script&lang=js"
export * from "./SelectionTile.vue?vue&type=script&lang=js"
import style0 from "./SelectionTile.vue?vue&type=style&index=0&id=89b3903e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports